import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchCollaboratorComponent } from './search-collaborator.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [SearchCollaboratorComponent],
  exports: [SearchCollaboratorComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class SearchCollaboratorModule {}
